import React, { useState } from 'react'
import './navbar.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import { RiMenu3Line, RiCloseLine } from 'react-icons/ri'

import logo from '../../assets/images/logo.png'

const Menu = () => (
  <>
    <ul>
      <li>
        {' '}
        <a href='#' className='active_tag'>
          Home{' '}
        </a>
      </li>
      <li>
        {' '}
        <a href='#'>About </a>
      </li>
      <li>
        {' '}
        <a href='#'>News </a>
      </li>
      <li>
        {' '}
        <a href='#'>Services </a>
      </li>
      <li>
        {' '}
        <a href='#'>Contact </a>
      </li>
    </ul>
  </>
)

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false)

  return (
    <div className='Navbar__wrap'>
      <div className='Navbar'>
        <div className='container'>
          <div className='Navbar__logo'>
            <img src={logo} alt='' />
            <a href='#'>
              Weather<span className='active_tag1'>Lite.</span>
            </a>
          </div>
          <div className='Navbar__links'>
            <Menu />
          </div>
        </div>
      </div>

      {/* Menu toggle up navbar */}
      <div className='Navbar__menu'>
        {toggleMenu ? (
          <RiCloseLine
            color='#fff'
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color='#fff'
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}

        {toggleMenu && (
          <div className='Navbar__menu__container scale-up-hor-right'>
            <div className='Navbar__menu__container__links'>
              <Menu />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar
